import { render } from "./DocsRules.vue?vue&type=template&id=0dce1bc0"
import script from "./DocsRules.vue?vue&type=script&lang=js"
export * from "./DocsRules.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DocsRules.vue?vue&type=style&index=0&id=0dce1bc0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__